var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOfRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.82,10.33V21.75a.24.24,0,0,0,.4.19L16.9,18a.23.23,0,0,1,.31,0l4.38,3.89a.25.25,0,0,0,.41-.19V10.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.82,10.33V21.75a.24.24,0,0,0,.4.19L16.9,18a.23.23,0,0,1,.31,0l4.38,3.89a.25.25,0,0,0,.41-.19V10.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4,9.92h5.68V6.17H6.91V17.58a.25.25,0,0,0,.4.2l4.09-3.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49,5.75h5.68V2H2V13.41a.25.25,0,0,0,.4.2l4.09-3.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOfRooms);
export default __webpack_public_path__ + "static/media/no-of-rooms.b4bcfbe21afe605e556221f7b66aa092.svg";
export { ForwardRef as ReactComponent };